// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_B6y","cls2":"SimplePaperPodcast-cls2_PqR SimplePaperPodcast-cls1_B6y"};